import React from 'react';
import { createRoot } from 'react-dom/client';
import '../../src/styles/artist-details.less';
import ProducerDetails from '../../src/js/producerDetails/ProducerDetails';
import { authController } from '@reedexpo/authorization-component-ui';

if (global.window && global.window.document) {
  const { props, elementId, idpUrl } = window.reactSettings || window.reactSettingsArtistDetails;
  const authSettings = window.authSettings;
  if (authSettings && authSettings.usePkce) {
    authController.initialize(authSettings);
  }
  const propsForChildren = Object.assign({}, props, { idpUrl: props.idpUrl || idpUrl });

  const container = document.getElementById(elementId);
  const root = createRoot(container);
  root.render(<ProducerDetails {... propsForChildren} />);
}
